import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/estudos.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-38733b54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-template" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "titulo-principal" }, "Sobre o Desafio - Física", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "utensilios",
    src: _imports_0,
    alt: "livros"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "first" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Fundada para democratizar o acesso a universidade, o "),
      /*#__PURE__*/_createElementVNode("strong", null, "Projeto Desafio"),
      /*#__PURE__*/_createTextVNode(" traz para o público estudantil de diferentes classes o esforço coletivo de universitários em oferecer aulas com os conteúdos programáticos das áreas cobradas nos vestibulares. Nesse contexto, o grupo de alunos responsáveis pela área da Física reune aulas e artigos com os temas tratados durante o ano letivo neste website. ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "second" }, [
      /*#__PURE__*/_createElementVNode("p", { id: "conteudo" }, [
        /*#__PURE__*/_createElementVNode("em", null, [
          /*#__PURE__*/_createTextVNode("Nossos conteúdos principais são dividos em: "),
          /*#__PURE__*/_createElementVNode("strong", null, "\"Mecânica\", \"Termodinâmica, \"Ondulatória\", e \"Eletromagnetismo\" "),
          /*#__PURE__*/_createTextVNode(" . ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("p", null, " Os professores são da área da licenciatura, e procuram apresentar os conceitos mais relevantes, se dedicando para esclarecer dúvidas e auxiliar na resolução de exercícios. ")
    ])
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}